// Copyright 2024 praveen.konathala
//
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
//     https://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.

import { AppConfig } from 'src/config/AppConfig';
import { Config } from 'src/context/ConfigContext';
function buildApiUrl(
  baseUrl: string,
  queryParams: Record<string, string>,
): string {
  const url = new URL(baseUrl);

  Object.keys(queryParams).forEach((key) => {
    const value = queryParams[key];
    if (value) {
      // Check if value is not empty
      url.searchParams.append(key, value);
    }
  });

  return url.toString();
}

export function FilterMapper(
  account: string,
  config: Config, // Assuming config type for now
  requester: string,
  startDate: string,
  endDate: string,
  report: string,
  timeStamp: string,
  filters: string,
): string {
  return buildApiUrl(config.API_URL.dash_filter, {
    account,
    page: '1',
    requester,
    start: startDate,
    end: endDate,
    report,
    timeStamp,
    filters,
  });
}
export function UrlMapper(
  account: string,
  url: string, // Assuming config type for now
  requester: string,
  startDate: string,
  endDate: string,
  report: string,
  timeStamp: string,
  filters: string,
): string {
  return buildApiUrl(url, {
    account,
    page: '1',
    requester,
    start: startDate,
    end: endDate,
    report,
    timeStamp,
    filters,
  });
}

export function getUrlForReports(
  API_URL: Record<string, string>,
  tile: string,
) {
  let url: string | undefined = '';
  if (tile === AppConfig.reports[0] || tile === AppConfig.reports[1]) {
    url = API_URL.transactions;
  } else if (tile === AppConfig.reports[2]) {
    url = API_URL.sales_summary;
  } else if (tile === AppConfig.reports[3]) {
    url = API_URL.inventory_event;
  } else if (tile === AppConfig.reports[4]) {
    url = API_URL.inventory_snapshot;
  } else if (tile === AppConfig.reports[5]) {
    url = API_URL.warehouse_inventory;
  } else if (tile === AppConfig.reports[6]) {
    url = API_URL.network_availability;
  } else if (tile === AppConfig.reports[7]) {
    url = API_URL.sessions_summary;
  } else if (tile === AppConfig.reports[8]) {
    url = API_URL.marketing_survey;
  }
  return url;
}
